import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const Section = ({ title, children }) => (
  <Paper sx={{ p: 2, mb: 2, borderLeft: "5px solid #00838f" }} elevation={1}>
    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
      {title}
    </Typography>
    {children}
  </Paper>
);

const KeyValue = ({ label, value }) => (
  <Typography variant="body2" sx={{ mb: 0.5, wordBreak: "break-word" }}>
    <strong>{label}:</strong> {value || "-"}
  </Typography>
);

const LabReportGrid = ({ report }) => {
  if (!report) return null;

  const { header, metadata, specimen, Ungrouped, ...testGroups } = report;

  return (
    <Box sx={{ mt: 2 }}>
      {/* HEADER */}
      <Section title="Report Category">
        <KeyValue label="Category" value={header?.report_categories} />
      </Section>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          width: "100%",
          justifyContent: "space-between",
          alignItems: "stretch",
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 300 }}>
          <Section title="Metadata">
            {Object.entries(metadata || {}).map(([k, v]) => (
              <KeyValue key={k} label={k} value={v} />
            ))}
          </Section>
        </Box>

        <Box sx={{ flex: 1, minWidth: 300 }}>
          <Section title="Specimen Information">
            {Object.entries(specimen || {}).map(([k, v]) => (
              <KeyValue key={k} label={k} value={v} />
            ))}
          </Section>
        </Box>
      </Box>

      {Ungrouped && (
        <Section title="Notes">
          {Object.entries(Ungrouped).map(([k, v]) => (
            <KeyValue
              key={k}
              label={k}
              value={typeof v === "string" ? v : v?.freetext}
            />
          ))}
        </Section>
      )}

      {Object.entries(testGroups).map(([groupName, tests]) => (
        <Section key={groupName} title={groupName}>
          {Object.entries(tests).map(([testName, t]) => (
            <Box key={testName} sx={{ mb: 1.5 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                {testName}
              </Typography>
              {t?.value && <KeyValue label="Value" value={t.value} />}
              {t?.range && <KeyValue label="Range" value={t.range} />}
              {t?.abnormal_flag && (
                <KeyValue label="Flag" value={t.abnormal_flag} />
              )}
              {t?.freetext && (
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    mt: 0.5,
                  }}
                >
                  {t.freetext}
                </Typography>
              )}
            </Box>
          ))}
        </Section>
      ))}
    </Box>
  );
};

export default LabReportGrid;
